'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _taReactTrackingpixel = require('ta-react-trackingpixel');

var _taReactTrackingpixel2 = _interopRequireDefault(_taReactTrackingpixel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @file NewsnetTracker component class to render an invisible pixel image
 * that tracks the hits on the page.
 */

function NewsnetTracker(props) {

  if (!props.articleId) {
    console.info('[NewsnetTracker] No Article ID has been provided, aborting.');
    return null;
  }

  var hostname = '';

  if (!('hostname' in props)) {

    // no need for tracking on localhost
    if (window.location.hostname == 'localhost') {
      console.info('[NewsnetTracker] Host name is localhost, aborting.');
      return null;
    }

    // Get the host name from the window location, split it at the periods,
    // which gives an array, then take the last two elements and join them
    // together again = removes all subdomains.
    hostname = window.location.hostname.split('.').slice(-2).join('.');
  } else {
    hostname = props.hostname;
  }

  if (hostname === '') {
    //Hey, that shouldn't happen! Let's die instead, because we're not
    // getting a proper URL out of this anyway.
    console.info('[NewsnetTracker] Host name is still undefined, aborting.');
    return null;
  }

  // Differentiate between mobile and desktop devices
  var userAgentMarker = 1;
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent)) {
    userAgentMarker = 2;
  }

  return _react2.default.createElement(_taReactTrackingpixel2.default, {
    url: 'http://www.' + hostname + '/story/' + props.articleId + '/' + userAgentMarker + '/pixel.gif?nocache=' + Math.random() * 100000 });
}

NewsnetTracker.propTypes = {
  /**
   * The article ID as displayed in CD.
   */
  articleId: _react2.default.PropTypes.string.isRequired,
  /**
   * Force a host name for tracking. If not provided, will be read from
   * window.location.
   */
  hostname: _react2.default.PropTypes.string
};

exports.default = NewsnetTracker;


//////////////////
// WEBPACK FOOTER
// ./~/ta-react-newsnettracker/dist/index.js
// module id = 116
// module chunks = 0